<div class="contenedor">
  <div class="header">
    <h2 class="title">{{ title }}</h2>
    <div class="button-group">
      <div class="container-template-state">
        <span *ngIf="!isNewDocument && isAutoSaveSuccess" class="ultimo-guardado">Ultimo Guardado: {{ dateAutoSave | date : 'dd/MM/yyyy' }} {{ dateAutoSave | date : "shortTime" }}Hrs</span>
        <span *ngIf="!isAutoSaveSuccess" class="error-message">
          <mat-icon color="warn">warning</mat-icon>
          Error al guardar el documento        
        </span>  
      </div>
      <button mat-stroked-button (click)="openModalConfig(data)">
        <mat-icon>build</mat-icon>
      </button>
      <button mat-stroked-button color="primary" (click)="onSave()" [disabled]="loadingSaveDocument">Guardar</button>
      <button mat-stroked-button color="warn" (click)="closeEditorModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="contenedor-editor">
    <editor #editor apiKey="{{apiKeyTiny}}" [init]="init" />
  </div>
</div>